import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import middleDocument from './documents/middleDocument.vue';
import cclSuggestions from './conclusionSuggestions/cclSuggestions.vue';
import resultSuggestions  from './resultSuggestions/resultSuggestions.vue';

import { computed } from 'vue';
import { useCurrentEntryStore } from '@/stores/currentEntry';



export default /*@__PURE__*/_defineComponent({
  __name: 'middleColumn',
  setup(__props) {

const currentEntryStore = useCurrentEntryStore();

const middleTab = computed(() => {
  const middleTabList = {
    "resultSuggestions": resultSuggestions,
    "cclSuggestions": cclSuggestions,
    "docTemplate": middleDocument,
  }
  return middleTabList[currentEntryStore.middleTab];
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(middleTab.value), {
    style: {"grid-area":"dashbRight"},
    class: "events-1"
  }))
}
}

})